module.exports = __webpack_public_path__ + "static/media/badge-normal1.200af9b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/badge-normal1.svg
// module id = 1642
// module chunks = 0